import * as types from 'modules/predefinedMessages/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const load = () => true;

const reset = () => false;

export default createReducer(initialState, {
  [types.CLONE]: load,
  [types.CLONE_FAILURE]: reset,
  [types.CLONE_SUCCESS]: reset,
});
